import React from 'react';
import { Col, Container, Row, Table } from 'reactstrap';
import { Apify } from '../Apify';
import { connect } from 'react-redux';
import { T } from '../traks';
import API from '../API';

var FlaggedPortfolios = (props) => {
    let rows = [];

    if (props.flagged) {
        for (const portfolio of props.flagged) {
            rows.push(
                <tr key={portfolio.Id} className="ad_game_table_border ad_grey_hover">
                    <td className="fw-bold">{portfolio.Id}</td>
                    <td className="fw-bold">{portfolio.ScreenName}</td>
                    <td className="fw-bold">{portfolio.Email}</td>
                    <td className="fw-bold">{portfolio.OwnerUserId}</td>
                    <td className="fw-bold">{new Date(portfolio.FlaggedAt).toLocaleString()}</td>
                    <td className="fw-bold">
                        <a href={`/portfolio/${portfolio.Id}`}
                            className="btn btn-sm"
                        >
                            Se portfolio
                        </a>
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                if (window.confirm("Are you sure you want to unflag this portfolio?")) {
                                    API.post("/a/unflag_portfolio", { portfolio_id: portfolio.Id }, () => {
                                        props.ctl.reload();
                                    });
                                }
                            }}
                        >
                            Unflag
                        </button>
                    </td>
                </tr>
            );
        }
    }

    return (
        <Container className="mt-4 mb-4">
            <Row className="ad_game_box flex-column">
                <Row xs="12" className="py-4 px-3">
                    <Col xs="12">
                        <h3>Flagged Portfolios</h3>
                    </Col>
                </Row>
                {rows.length === 0 ? (
                    <Row className="pb-1">
                        <Col md="12">
                            <div className="ad_notification_box py-2 px-4">
                                <div className="ad_notification_header">No flagged portfolios yet.</div>
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="ad_notification_box ad_game_box pt-3">
                        <Col xs="12" className="overflow-auto">
                            <div className="ad_trade_history_table_wrapper">
                                <Table className="bg-color-white">
                                    <thead>
                                        <tr>
                                            <th className="ad_game_table_header font-s pl-3 text-uppercase text-nowrap">Portfolio ID</th>
                                            <th className="ad_game_table_header font-s pl-3 text-uppercase text-nowrap">Spillernavn</th>
                                            <th className="ad_game_table_header font-s pl-3 text-uppercase text-nowrap">Email</th>
                                            <th className="ad_game_table_header font-s pl-3 text-uppercase text-nowrap">Bruger ID</th>
                                            <th className="ad_game_table_header font-s pl-3 text-uppercase text-nowrap">Flagged tidspunkt</th>
                                            <th className="ad_game_table_header font-s pl-3 text-uppercase text-nowrap">Handling</th>
                                        </tr>
                                    </thead>
                                    <tbody>{rows}</tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                )}
                <div className="p-4"/>
            </Row>
        </Container>
    );
};

FlaggedPortfolios = Apify("/a/flagged_portfolios")
    .with_response_prop("flagged")
    .with_ctl_prop()
    .wrap(FlaggedPortfolios);

const FlaggedPortfoliosPage = connect(
    (state) => ({ me: state.me })
)((props) => {
    if (!props.me || !props.me.IsGod) {
        return "Access denied";
    }
    return <FlaggedPortfolios />;
});

export default FlaggedPortfoliosPage;


// WEBPACK FOOTER //
// ./src/p/FlaggedPortfolios.js